import React from "react";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";

import { configService, seasonService } from "../../../../Services";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import Layout from "../../../../components/Layout";
import ErrorMessage from "../../../../components/form/error-message";
import { controlType, validations } from "../../../../Constants";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";

interface FormValues {
  name: string;
  farmCategoryId: number;
  // startDate: Date;
  // endDate: Date;
  config: [
    {
      fieldName: string;
      controlType: string;
      validations: [];
      values: string;
    }
  ];
}

const Create_farm_stage = () => {
  const alert = useAlert();
  const history = useHistory();
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [field, setfield] = React.useState<[]>([]);

  const initialValues: FormValues = {
    name: "",
    farmCategoryId: 0,
    // startDate: new Date(),
    // endDate: new Date(),
    config: [
      {
        fieldName: "",
        controlType: "",
        validations: [],
        values: "",
      },
    ],
  };

  const getfield = async () => {
    updateLoader(true, "Fetching Farm Stages");
    const response = await seasonService.getAllField(1);

    let fd: any = [];
    response.data.data.map((dt: any) => {
      fd.push({
        label: dt,
        value: dt,
      });
    });
    setfield(fd);
    updateLoader(false, "");
  };

  React.useEffect(() => {
    getfield();
  }, []);
  return (
    <Layout active="Config">
      <Container>
        <Row>
          <Col>
            <div>
              <Formik
                initialValues={initialValues}
                validationSchema={Yup.object({
                  name: Yup.string().required("Name is required"),
                  farmCategoryId: Yup.number()
                    .min(1, "please select from the options")
                    .required("Farm category is required"),
                  config: Yup.array().of(
                    Yup.object().shape({
                      fieldName: Yup.string().required("name is  required"),
                      validations: Yup.array()
                        .min(1, "Validations is Required")
                        .required("Validations is Required"),
                      controlType: Yup.string().required(
                        "Control type is required"
                      ),
                      // startDate: Yup.date().required("Start date is required"),
                      // endDate: Yup.date().required(" End date is required"),
                      // quantity: Yup.string().required("Quantity is required"),
                      // unitPrice: Yup.string().required("Unit price  is required"),
                      // quantityType: Yup.string().required(
                      //   "Quantity type is required"
                      // ),
                    })
                  ),
                })}
                onSubmit={async (values, actions) => {
                  actions.setSubmitting(true);
                  let newArr: any = [];
                  values.config.map((re: any) => {
                    newArr.push(re.fieldName);
                    for (let i = 0; i < re.validations.length; i++) {
                      re.validations[i].validation = re.validations[i].value;
                      re.validations[i].validationValue = "";
                    }
                    if (re.controlType == "ColumnNameDropDown") {
                      const newField: any = [];
                      re.values.length > 0 &&
                        re.values.map((fr: { label: any; value: any }) => {
                          newField.push(fr.value);
                        });

                      re.values = String(newField);
                    }
                  });

                  // });
                  const toFindDuplicates = (newArr: any) =>
                    newArr.filter(
                      (item: any, index: any) => newArr.indexOf(item) !== index
                    );
                  const duplicateElementa = toFindDuplicates(newArr);

                  if (duplicateElementa.length > 0) {
                    alert.error("Duplicate Entry on Question Name");
                  } else {
                    try {
                      const response = await configService.createfarmingStages(
                        values
                      );
                      console.log(response);
                      if (response.data.data) {
                        alert.success("successfully created");
                        history.push("/config");
                      }
                    } catch (error: any) {
                      alert.error(error.response.data.message);
                    }
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  dirty,
                  isSubmitting,
                  values,
                  setFieldValue,
                }) => (
                  <Form>
                    <Row>
                      <Col className="my-auto">
                        <FormGroup className="">
                          <Label className="font-weight-bold">
                            Farming Stage Name{" "}
                            <span className="text-danger fw-bold">*</span>
                          </Label>
                          <Field
                            type="text"
                            placeholder="enter name"
                            name="name"
                            className="form-control form-control-lg"
                          />
                          {touched.name && errors.name ? (
                            <div className="text-danger">{errors.name}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col>
                        {/* <FormGroup className=""> */}
                        <Label className="font-weight-bold">
                          Category{" "}
                          <span className="text-danger fw-bold">*</span>{" "}
                        </Label>
                        <Field
                          name="farmCategoryId"
                          as="select"
                          className="form-control form-control-lg"
                        >
                          <option> Select</option>
                          <option value={1}>Pre-planting</option>
                          <option value={2}>Planting</option>
                          <option value={3}>Post-planting</option>
                        </Field>
                        {touched.farmCategoryId && errors.farmCategoryId ? (
                          <div className="text-danger">
                            {errors.farmCategoryId}
                          </div>
                        ) : null}
                        {/* </FormGroup> */}
                      </Col>
                    </Row>
                    <Row></Row>
                    <FieldArray
                      name="config"
                      render={(arrayHelpers) => (
                        <div>
                          {values.config.map((friend: any, index: number) => (
                            <React.Fragment>
                              <Row className="my-2 bg-green-3 p-3">
                                <Col>
                                  <FormGroup>
                                    <Label className="font-weight-bold">
                                      Enter Question
                                    </Label>
                                    <Field
                                      type="text"
                                      placeholder="field name"
                                      name={`config[${index}].fieldName`}
                                      className="form-control form-control-lg"
                                    />
                                    <div className="text-danger">
                                      <ErrorMessage
                                        name={`config[${index}].fieldName`}
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>

                                <Col>
                                  <FormGroup className="">
                                    <Label className="font-weight-bold">
                                      Type of Answer Expected
                                    </Label>

                                    <Field
                                      name={`config[${index}].controlType`}
                                      as="select"
                                      className="form-control form-control-lg"
                                    >
                                      <option> Select</option>
                                      {/* <option value="Input">Input</option>
                                  <option value="Others">Others</option> */}
                                      {controlType.map((ass: any, i: any) => (
                                        <option value={ass}>{ass}</option>
                                      ))}
                                    </Field>
                                    <div className="text-danger">
                                      <ErrorMessage
                                        name={`config[${index}].controlType`}
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup className="">
                                    <Label className="font-weight-bold">
                                      Select Validation Type
                                    </Label>
                                    <Select
                                      onChange={(th: any) => {
                                        setFieldValue(
                                          `config[${index}].validations`,
                                          th
                                        );
                                      }}
                                      options={validations}
                                      isMulti={true}
                                      name={`config[${index}].validations`}
                                    />
                                    <div className="text-danger">
                                      <ErrorMessage
                                        name={`config[${index}].validations`}
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                                {values.config[index].controlType ==
                                "DropDown" ? (
                                  <Col>
                                    <FormGroup className="">
                                      <Label className="font-weight-bold">
                                        Dropdown Values
                                      </Label>
                                      <Field
                                        type="text"
                                        placeholder="eg: male,female"
                                        name={`config[${index}].values`}
                                        className="form-control form-control-lg"
                                        valid
                                      />
                                      <small> (Comma Separated) </small>
                                      <div className="text-danger">
                                        <ErrorMessage
                                          name={`config[${index}].values`}
                                        />
                                      </div>
                                    </FormGroup>
                                  </Col>
                                ) : null}

                                {values.config[index].controlType ==
                                "ColumnNameDropDown" ? (
                                  <Col>
                                    <FormGroup className="">
                                      <Label className="font-weight-bold">
                                        Dropdown Values
                                      </Label>
                                      <Select
                                        onChange={(th: any) => {
                                          setFieldValue(
                                            `config[${index}].values`,
                                            th
                                          );
                                        }}
                                        options={field}
                                        isMulti={true}
                                        name={`config[${index}].values`}
                                      />
                                      <div className="text-danger">
                                        <ErrorMessage
                                          name={`config[${index}].values`}
                                        />
                                      </div>
                                    </FormGroup>
                                  </Col>
                                ) : null}

                                <Button
                                  close
                                  className="text-danger"
                                  onClick={() => arrayHelpers.remove(index)}
                                />
                              </Row>
                            </React.Fragment>
                          ))}
                          <Button
                            color="success"
                            type="button"
                            className="btn-create px-4 py-2 shadow font-weight-bold bg-or"
                            onClick={() =>
                              arrayHelpers.push({
                                fieldName: "",
                                controlType: "",
                                validations: [],
                                values: "",
                              })
                            }
                          >
                            Add
                          </Button>
                        </div>
                      )}
                    />
                    <div className="p-3 text-center">
                      <Link to="/config">
                        <Button
                          color="success"
                          className="btn-cancel px-4 py-2 shadow font-weight-bold m-5"
                        >
                          Cancel
                        </Button>
                      </Link>
                      <Button
                        type="submit"
                        color="success"
                        className="btn-create px-4 py-2 shadow font-weight-bold"
                        disabled={isSubmitting}
                      >
                        Create
                        {isSubmitting ? (
                          <FaSpinner className="fa-spin" />
                        ) : null}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default Create_farm_stage;
